// import { useLocation } from "react-router-dom";
// import ContactSection from "../components/ContactForm";
// import Footer from "../components/Footer";
// import Header from "../components/Header";
// import HeroSection from "../components/HeroSection";
// import HeroSection2 from "../components/HeroSection2";
// import ServicesSection from "../components/Services";
// import { useEffect } from "react";

// export default function ContactUs () {
//     const { pathname } = useLocation();
//     useEffect(() => {
//       window.scrollTo(0, 0);
//     }, [pathname]);

//    return(
//     <div className="font-body">
//     <Header />
      
//       <ContactSection />
//       <Footer />
//   </div>
//    )
  
// }

import { useState, useEffect } from 'react';
import { PhoneCall, Mail, MapPin, Clock, MessageSquare, Users, CheckCircle, Send, ChevronRight } from 'lucide-react';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';

export default function ContactUs() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState('contact');
  
  const [isVisible, setIsVisible] = useState({
    hero: false,
    form: false,
    info: false,
    faq: false,
    locations: false
  });
  
  // Intersection Observer for animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    const sections = ['hero', 'form', 'info', 'faq', 'locations'];
    sections.forEach(section => {
      const element = document.getElementById(section);
      if (element) observer.observe(element);
    });
    
    return () => {
      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) observer.unobserve(element);
      });
    };
  }, []);
  
  // Animation classes
  const getAnimationClass = (section) => {
    return isVisible[section] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10';
  };
  
  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };
  
  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formState);
    setIsSubmitted(true);
    
    // Reset after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    }, 5000);
  };
  
  // FAQ items
  const faqItems = [
    {
      question: "What areas do you service?",
      answer: "We provide installation and service throughout the greater metropolitan area and surrounding suburbs within a 50-mile radius. For locations outside this area, please contact us to discuss options."
    },
    {
      question: "How long does installation take?",
      answer: "Installation time varies by system type. Countertop and under-sink systems typically take 1-2 hours, while whole-house systems usually require 3-5 hours. Our technicians will provide a specific timeframe during your consultation."
    },
    {
      question: "Do you offer maintenance services?",
      answer: "Yes! We provide comprehensive maintenance plans for all our filtration systems. Regular maintenance ensures optimal performance and extends the life of your system. We recommend service every 6-12 months depending on your water quality and usage."
    },
    {
      question: "How often do filters need replacement?",
      answer: "Filter replacement schedules vary by filter type and water quality. Generally, sediment pre-filters need replacement every 3-6 months, carbon filters every 6-12 months, and RO membranes every 2-3 years. We'll provide a custom schedule based on your specific system and water conditions."
    }
  ];
  
  // Office locations
  const locations = [
    {
      city: "Main Office - Clearwater",
      address: "Australia",
      phone: "(123) 456-7890",
      hours: "Monday-Friday: 8am-6pm, Saturday: 9am-2pm"
    },
 
  ];

  return (
    <div className="min-h-screen  container bg-gradient-to-b from-gray-50 to-gray-100">
      {/* Hero Section */}
      <NavBar />
      <div id="hero" className={`relative bg-gradient-to-r from-blue-600 to-blue-500 text-white overflow-hidden transition-all duration-1000 ${getAnimationClass('hero')}`}>
        {/* Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>
          <div className="absolute top-1/2 -right-24 w-80 h-80 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-60"></div>
          <div className="absolute -bottom-32 left-1/2 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60"></div>
        </div>
        
        {/* Content */}
        <div className="container mx-auto px-4 py-24 md:py-32 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">Contact Us</h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed font-light">
              We're here to answer your questions and provide solutions for all your water filtration needs.
            </p>
            {/* <div className="flex justify-center space-x-4">
              <a href="#form" className="bg-white text-blue-600 px-8 py-3 rounded-full font-medium hover:bg-opacity-90 transition-all duration-300 inline-flex items-center group">
                Get in Touch <ChevronRight size={18} className="ml-1 transform group-hover:translate-x-1 transition-transform duration-300" />
              </a>
              <a href="tel:+11234567890" className="bg-blue-700 text-white px-8 py-3 rounded-full font-medium hover:bg-blue-800 transition-all duration-300 inline-flex items-center">
                <PhoneCall size={18} className="mr-2" /> Call Now
              </a>
            </div> */}
          </div>
        </div>
        
        {/* Wave Divider */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" className="w-full text-gray-50 fill-current">
            <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
          </svg>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Contact Form Section */}
          <div id="form" className={`md:col-span-2 transition-all duration-1000 delay-200 ${getAnimationClass('form')}`}>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 text-white">
                <div className="flex items-center">
                  <MessageSquare size={30} className="mr-4" />
                  <h2 className="text-2xl font-bold">Send Us a Message</h2>
                </div>
                <p className="mt-2 text-blue-100">We'll get back to you within 24 hours</p>
              </div>
              
              <div className="p-6 md:p-8">
                {isSubmitted ? (
                  <div className="flex flex-col items-center justify-center py-12 text-center">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                      <CheckCircle size={32} className="text-green-600" />
                    </div>
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">Message Sent!</h3>
                    <p className="text-gray-600 mb-6">Thanks for reaching out. We'll be in touch soon.</p>
                    <button 
                      onClick={() => setIsSubmitted(false)} 
                      className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-300"
                    >
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="name">Your Name*</label>
                        <input 
                          type="text" 
                          id="name"
                          name="name"
                          value={formState.name}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                          placeholder="Full name"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="email">Email Address*</label>
                        <input 
                          type="email"
                          id="email"
                          name="email"
                          value={formState.email}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                          placeholder="your@email.com"
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="phone">Phone Number</label>
                        <input 
                          type="tel" 
                          id="phone"
                          name="phone"
                          value={formState.phone}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                          placeholder="(123) 456-7890"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="subject">Subject*</label>
                        <select 
                          id="subject"
                          name="subject"
                          value={formState.subject}
                          onChange={handleChange}
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300"
                          required
                        >
                          <option value="">Select a subject</option>
                          <option value="sales">Sales Inquiry</option>
                          <option value="support">Technical Support</option>
                          <option value="service">Service Request</option>
                          <option value="billing">Billing Question</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="message">Your Message*</label>
                      <textarea 
                        id="message"
                        name="message"
                        value={formState.message}
                        onChange={handleChange}
                        rows="5" 
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300" 
                        placeholder="Tell us how we can help you..."
                        required
                      ></textarea>
                    </div>
                    
                    <div className="flex items-center">
                      <input 
                        type="checkbox" 
                        id="consent" 
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" 
                        required
                      />
                      <label htmlFor="consent" className="ml-2 block text-sm text-gray-700">
                        I consent to having Home Filtaration System collect my data via this form.
                      </label>
                    </div>
                    
                    <button 
                      type="submit" 
                      className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white font-medium py-3 px-6 rounded-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                    >
                      <Send size={18} className="mr-2" /> Send Message
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
          
          {/* Contact Information Sidebar */}
          <div id="info" className={`transition-all duration-1000 delay-300 ${getAnimationClass('info')}`}>
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 h-full">
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 text-white">
                <h2 className="text-2xl font-bold">Contact Information</h2>
              </div>
              
              <div className="p-6 space-y-6">
                {/* <div className="flex">
                  <div className="bg-blue-100 rounded-full p-3 text-blue-600 mr-4">
                    <PhoneCall size={20} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Phone</h3>
                    <p className="text-gray-600">(123) 456-7890</p>
                    <p className="text-sm text-gray-500 mt-1">Toll-free: 1-800-PUREFLOW</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-blue-100 rounded-full p-3 text-blue-600 mr-4">
                    <Mail size={20} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Email</h3>
                    <p className="text-gray-600">info@pureflowwater.com</p>
                    <p className="text-sm text-gray-500 mt-1">support@pureflowwater.com</p>
                  </div>
                </div> */}
                
                <div className="flex">
                  <div className="bg-blue-100 rounded-full p-3 text-blue-600 mr-4">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Headquarters</h3>
                    {/* <p className="text-gray-600">123 Water Lane</p> */}
                    <p className="text-gray-600">Australia</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="bg-blue-100 rounded-full p-3 text-blue-600 mr-4">
                    <Clock size={20} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Business Hours</h3>
                    <p className="text-gray-600">Monday-Friday: 8am-6pm</p>
                    <p className="text-gray-600">Saturday: 9am-2pm</p>
                    <p className="text-gray-600">Sunday: Closed</p>
                  </div>
                </div>
                
                <div className="pt-4">
                  <h3 className="font-semibold text-gray-800 mb-3">Connect With Us</h3>
                  <div className="flex space-x-3">
                    <a href="#" className="bg-blue-100 p-2 rounded-full text-blue-600 hover:bg-blue-200 transition-colors duration-300">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                      </svg>
                    </a>
                    <a href="#" className="bg-blue-100 p-2 rounded-full text-blue-600 hover:bg-blue-200 transition-colors duration-300">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                      </svg>
                    </a>
                    <a href="#" className="bg-blue-100 p-2 rounded-full text-blue-600 hover:bg-blue-200 transition-colors duration-300">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                      </svg>
                    </a>
                    <a href="#" className="bg-blue-100 p-2 rounded-full text-blue-600 hover:bg-blue-200 transition-colors duration-300">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* FAQ Section */}
      <div id="faq" className={`bg-white py-16 transition-all duration-1000 delay-400 ${getAnimationClass('faq')}`}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-700">Frequently Asked Questions</h2>
            <p className="text-gray-600 max-w-2xl mx-auto text-lg">
              Find quick answers to common questions
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6">
            {faqItems.map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
                <h3 className="text-lg font-semibold text-blue-700 mb-3">{item.question}</h3>
                <p className="text-gray-600">{item.answer}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-10">
            <p className="text-gray-600 mb-4">Don't see your question here?</p>
            <a href="#form" className="inline-flex items-center text-blue-600 font-medium hover:text-blue-700 transition-colors duration-300">
              Ask us directly <ChevronRight size={16} className="ml-1" />
            </a>
          </div>
        </div>
      </div>
      
      {/* Office Locations */}
      <div id="locations" className={`container mx-auto px-4 py-16 transition-all duration-1000 delay-500 ${getAnimationClass('locations')}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-700">Our Locations</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Visit one of our offices for in-person consultations
          </p>
        </div>
        
        <div className="flex flex-col items-center space-y-6">

          {locations.map((location, index) => (
            <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="h-40 bg-blue-500 relative">
                {/* Placeholder for map image */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-blue-600 opacity-50"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <MapPin size={40} className="text-white opacity-80" />
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-blue-700 mb-2">{location.city}</h3>
                <div className="space-y-3 text-gray-600">
                  <p className="flex items-start">
                    <MapPin size={18} className="mr-2 text-blue-500 flex-shrink-0 mt-1" />
                    <span>{location.address}</span>
                  </p>
                  {/* <p className="flex items-start">
                    <PhoneCall size={18} className="mr-2 text-blue-500 flex-shrink-0 mt-1" />
                    <span>{location.phone}</span>
                  </p> */}
                  <p className="flex items-start">
                    <Clock size={18} className="mr-2 text-blue-500 flex-shrink-0 mt-1" />
                    <span>{location.hours}</span>
                  </p>
                </div>
                {/* <div className="mt-6">
                  <a 
                    href={`https://maps.google.com/?q=${encodeURIComponent(location.address)}`}
                    target="_blank"
                    rel="noopener noreferrer" 
                    className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors duration-300"
                  >
                    Get Directions <ChevronRight size={16} className="ml-1" />
                  </a>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
     </div>
  )
}